import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Hero from '../components/Hero';
import About from '../components/About';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Projects from '../components/Projects';
import SEO from '../components/SEO';

function Home() {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO 
        title={`${t('hero.name')} - ${t('hero.title')}`}
        description={t('hero.subtitle')}
      />
      <Box sx={{ bgcolor: 'background.default', overflowX: 'hidden', width: '100%' }}>
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Projects />
      </Box>
    </>
  );
}

export default Home;

